<template>
  <div class="generate-result-page">
    <!-- 导航栏：统一风格 -->
    <div class="custom-nav-bar" v-if="currentPlatform !== 'weixin'">
      <div class="back-btn" @click="onBack">
        <img src="@/assets/back.svg" class="back-icon" />
      </div>
      <div class="nav-title">声音定制</div>
    </div>
    <div class="page-body">
      <div class="bodayTitle">朗读以下内容</div>
      <div class="readText">
        旧书店最深的角落里，我遇见了十岁的自己。他正踮脚够一本《星星的童话》，指间还粘着没洗干净的蓝墨水。我想提醒他那本书的结局，他却把食指竖在唇边——嘘，有些谜题要自己走到结尾。
      </div>
      <div class="bodayTitle">提示</div>
      <div class="markedWord">
        <div>1、您可以预读几遍、熟练后再朗读录制</div>
        <div>2、请保持平时的说话语速，不要过快或过慢</div>
        <div>
          3、请有感情的朗读，注意正常的停歇和断句，吐字清楚，尽量使用普通话
        </div>
        <div>4、选择安静无杂音的环境录制可使声音更真实</div>
      </div>
      <div class="recordArea">
        <div v-if="this.recordIngType == '2'">
          <img src="@/assets/aiVideo/bl.png" alt="#" class="recordArea-bl" />
        </div>
        <div v-if="this.recordIngType == '1'">
          <img src="@/assets/aiVideo/blDt.gif" alt="#" class="recordArea-bl" />
        </div>
        <div class="lyTime">{{ formattedTime }}</div>
        <div class="recordAreaCenter">
          <div @click="deleteRecord" v-show="this.recordIngType == '2'">
            <img src="@/assets/aiVideo/delete.svg" alt="#" />
          </div>

          <div @click="changeRecordIngType()">
            <div class="bfk" v-if="this.recordIngType == '1'"></div>
            <img v-else src="@/assets/aiVideo/mkf.png" alt="#" class="mkfImg" />
          </div>
          <div v-show="this.recordIngType == '2'" @click="submitFile()">
            <img src="@/assets//aiVideo/submit.svg" alt="#" />
          </div>
        </div>
        <div class="lyText">
          {{
            this.recordIngType == "0"
              ? "点击开始录制"
              : this.recordIngType == "1"
              ? "点击停止录制"
              : "点击重新录制"
          }}
        </div>
      </div>
    </div>
    <!-- <loadingVue v-model="isLoading" text="文件上传中..." /> -->
  </div>
</template>

<script>
import { voUpload, createFile, voDelete } from "@/api";

// import loadingVue from "@/components/loadingVue.vue";
import { Toast } from "vant";
export default {
  name: "customVoice",
  // components: { loadingVue },

  data() {
    return {
      recordIngType: "0", // '0': 未开始, '1': 录制中, '2': 已完成
      mediaRecorder: null,
      audioChunks: [],
      audioStream: null,
      audioBlob: null, // 可选：保存最终录音 Blob 用于上传
      startTime: null, // 记录录音开始的时间戳
      currentTime: 0, // 当前录音经过的秒数
      interval: null, // 定时器ID
	  currentPlatform: '',
      // isLoading: false,
    };
  },
  mounted(){
	  document.title = "声音定制";
	  this.currentPlatform = sessionStorage.getItem('h5_uni_platform');
  },
  computed: {
    formattedTime() {
      const date = new Date(null);
      date.setSeconds(this.currentTime);
      const pad = (time) => `0${time}`.slice(-2);
      return `${pad(date.getUTCHours())}:${pad(date.getMinutes())}:${pad(
        date.getSeconds(),
      )}`;
    },
  },
  methods: {
    onBack() {
      this.$router.go(-1);
    },

    deleteRecord() {
      this.cleanup();
      this.recordIngType = "0";
    },

    async changeRecordIngType() {
      if (this.recordIngType === "0") {
        await this.startRecording();
      } else if (this.recordIngType === "1") {
        if (this.currentTime < 10) {
          this.stopRecording();
          this.deleteRecord(); // 重新录制 = 删除 + 回到初始
          this.$toast && this.$toast("定制声音不可少于10秒,请重新录制");
        } else {
          this.stopRecording();
        }
      } else if (this.recordIngType === "2") {
        this.deleteRecord(); // 重新录制 = 删除 + 回到初始
      }
    },

    async startRecording() {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          audio: true,
        });
        this.audioStream = stream;
        this.startTime = Date.now(); // 记录开始时间
        this.interval = setInterval(() => {
          this.currentTime = Math.floor((Date.now() - this.startTime) / 1000); // 更新经过的秒数
        }, 1000); // 每秒更新一次
        // 尝试使用兼容格式
        const mimeType = MediaRecorder.isTypeSupported("audio/webm")
          ? "audio/webm"
          : "audio/mp4";
        this.mediaRecorder = new MediaRecorder(stream, { mimeType });

        this.audioChunks = [];
        this.mediaRecorder.ondataavailable = (e) => {
          if (e.data.size > 0) this.audioChunks.push(e.data);
        };

        this.mediaRecorder.onstop = () => {
          const blob = new Blob(this.audioChunks, { type: mimeType });

          // 转为 File（可选，但推荐）
          const extension = mimeType === "audio/mp4" ? "mp4" : "webm";
          this.audioBlob = new File([blob], `recording.${extension}`, {
            type: mimeType,
            lastModified: Date.now(),
          });
        };

        this.mediaRecorder.start();
        this.recordIngType = "1";
      } catch (err) {
        this.$toast &&
          this.$toast(
            "无法访问麦克风，请确保在 Chrome/Safari 浏览器中使用，并授予麦克风权限",
          );
        this.recordIngType = "0";
      }
    },

    stopRecording() {
      if (this.mediaRecorder && this.mediaRecorder.state === "recording") {
        this.mediaRecorder.stop();
      }
      clearInterval(this.interval); // 清除定时器
      this.cleanup();
      this.recordIngType = "2";
    },

    cleanup() {
      // 关闭麦克风轨道
      if (this.audioStream) {
        this.audioStream.getTracks().forEach((track) => track.stop());
        this.audioStream = null;
      }
      this.mediaRecorder = null;
      this.audioChunks = [];
      if (this.recordIngType === "2") {
        this.currentTime = 0; // 重置录音时间
      }
    },
    //上传文件
    async submitFile() {
      const formData = new FormData();
      formData.append("audioFile", this.audioBlob); // 后端将收到 Content-Type: video/webm
      formData.append("voType", "3");
      let spot = this.$route.query.formPath == "customAvatar" ? "1" : "2";
      formData.append("spot", spot);
      // this.isLoading = true;
      const data = await voUpload(formData);
      if (data) {
        Toast.loading({
          message: "加载中...",
          forbidClick: true,
          loadingType: "spinner",
          duration: 0, // 持续显示，直到关闭
        });
        const response = await fetch(data.fileUrl, {
          method: "PUT",
          mode: "cors",
          headers: {
            "Content-Type": data.fileType,
          },
          body: this.audioBlob,
        });

        if (response.ok) {
          Toast.clear();

          if (
            this.$route.query.formPath == "myFigure" ||
            this.$route.query.formPath == "videoCreation"
          ) {
            await createFile({
              voiceUrl: data.fileUrl.split("?")[0],
              voiceTime: data.videoTime,
            });
            this.$router.go(-1);
          } else {
            this.$router.go(-1);
          }
        } else {
          await voDelete(data.fileId);
          Toast.clear();
          this.$toast && this.$toast("上传失败，请重试");
        }
      }
    },
  },

  beforeUnmount() {
    // 页面销毁时清理资源
    this.cleanup();
    clearInterval(this.interval); // 确保清除定时器
  },
};
</script>

<style scoped>
/* 页面基础布局 */
.generate-result-page {
  width: 100vw;
  height: 100vh;
  height: 100dvh;
  background: #ffffff;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: fixed;
  top: 0;
  left: 0;
}

/* 导航栏（与原页面完全统一） */
.custom-nav-bar {
  width: 100%;
  height: 11.7333vw;
  background-image: linear-gradient(90deg, #e7f2fa 0%, #dbe2f1 100%);
  box-shadow: 0px 0.1333vw 0px 0px rgba(97, 182, 255, 0.3);
  position: relative;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  flex-shrink: 0;
}

.back-btn {
  width: 6.4vw;
  height: 6.4vw;
  position: absolute;
  left: 2.6667vw;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.back-icon {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.nav-title {
  font-family: SourceHanSansSC-Medium;
  font-size: 4.8vw;
  color: #000000;
  letter-spacing: 0.1333vw;
  text-align: center;
  line-height: 11.7333vw;
  font-weight: 500;
}
.page-body {
  overflow-y: auto;
  padding: 5.333vw 4.2666vw 0 4.2666vw;
}
.bodayTitle {
  height: 6.2666vw;
  color: #1f2226;
  font-weight: 700;
  font-size: 4.2666vw;
  text-align: left;
  line-height: 6.2666vw;
  opacity: 0.9;
  padding-bottom: 2.133vw;
  border-bottom: 0.2666vw solid #e4e8ec;
}
.readText {
  /* height: 42.666vw; */
  background: #f0f4f8;
  box-shadow: 0px 0px 0.5333vw 0px rgba(0, 0, 0, 0.1);
  border-radius: 2.1333vw;
  margin: 3.2vw 2.666vw 5.333vw 2.666vw;
  padding: 4.666vw 3.2vw 4.666vw 3.2vw;
  font-size: 3.733vw;
  color: #333333;
  font-weight: 400;
  line-height: 5.4666vw;
}
.markedWord {
  padding: 3.7333vw 5.333vw 0 5.333vw;
}
.markedWord > div {
  line-height: 4.8vw;
  font-size: 3.2vw;
  color: #1f2226;
  font-weight: 400;
  margin-bottom: 1.6vw;
}
.recordArea {
  width: 100vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: fixed;
  bottom: 2.1333vw;
  left: 0;
}
.recordAreaCenter {
  display: flex;
  align-items: center;
  justify-content: center;
}
.recordAreaCenter > div:nth-child(1),
.recordAreaCenter > div:nth-child(3) {
  width: 8vw;
  height: 8vw;
  background: #e4e8ec;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.recordAreaCenter > div:nth-child(1) > img,
.recordAreaCenter > div:nth-child(3) > img {
  width: 5.333vw;
  height: 5.333vw;
}
.recordAreaCenter > div:nth-child(2) {
  width: 13.333vw;
  height: 13.333vw;
  background-image: linear-gradient(148deg, #2fffb5 0%, #1e89ff 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 4.2666vw 8vw 3.2vw 8vw;
}
.mkfImg {
  width: 8vw;
  height: 8vw;
}
.bfk {
  width: 4.2666vw;
  height: 4.2666vw;
  background: #ffffff;
  border-radius: 0.5333vw;
}
.recordArea-bl {
  width: 30.4vw;
  height: 9.333vw;
}
.lyTime {
  line-height: 4.8vw;
  font-size: 3.2vw;
  color: #666666;
  font-weight: 500;
  margin-top: 10.666vw;
}
.lyText {
  line-height: 4.8vw;
  font-size: 3.2vw;
  color: #1f2226;
  font-weight: 400;
}
</style>
